import { withStyles } from '@material-ui/core';

import AppLoading from './component';
import styles from './styles';

export default withStyles(styles)(AppLoading);
